<template>
  <v-bottom-navigation
    grow
    app
  >
    <v-btn
      :to="{name: 'Estadisticas'}"
    >
      <v-img
        width="29x"
        max-height="29x"
        src="@/assets/icon/menu-barra.svg"
        alt="Ícono estadísticas"
        contain
      />
    </v-btn>
    <v-btn
      :to="{name: 'Inicio'}"
    >
      <v-img
        width="29x"
        max-height="29x"
        src="@/assets/icon/menu-home.svg"
        alt="Ícono home"
        contain
      />
    </v-btn>
    <v-btn
      :to="{name: 'RankingMobile'}"
    >
      <v-icon size="30" color="black">mdi-trophy-variant</v-icon>
    </v-btn>
  </v-bottom-navigation>

</template>

<script>
export default {
  name: 'TheBottomNavigation'
}
</script>

<style scoped>

</style>
